import React, { useState } from "react";
import { Download } from "lucide-react";

const ExportCsvButton = ({ onExport, label = "Export CSV" }) => {
    const [exporting, setExporting] = useState(false);
    const [error, setError] = useState("");

    const handleClick = async () => {
        setExporting(true);
        setError("");
        try {
            await onExport();
        } catch (e) {
            setError(e.message || "Export failed");
        } finally {
            setExporting(false);
        }
    };

    return (
        <div className="flex flex-col items-end">
            <button onClick={handleClick} disabled={exporting}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-white border-2 border-gray-200 text-gray-600 rounded-lg text-xs font-bold hover:bg-gray-50 transition disabled:opacity-50">
                <Download size={13} className={exporting ? "animate-pulse" : ""} /> {exporting ? "Exporting..." : label}
            </button>
            {error && <span className="text-[10px] text-red-500 mt-1">{error}</span>}
        </div>
    );
};

export default ExportCsvButton;